import { ChangeDetectorRef, Component } from '@angular/core';
import { CitydealsFormGroup } from '@partneradmin/common';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { CustomValidators } from 'ngx-custom-validators';
import { NgxFormErrorConfig } from '@partneradmin/feature/ngx-form-error';
import { ChangePasswordAction } from '../../../state/action/change-password.action';
import { timer } from 'rxjs';
import { environment } from '@partneradmin/env';
import { HttpClient } from '@angular/common/http';

@UntilDestroy()
@Component({
  selector: 'partneradmin-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [MessageService],
})
export class ChangePasswordComponent {
  readonly oldPasswordControl = new FormControl(null, Validators.required);
  readonly newPassword1Control = new FormControl(null, Validators.required);
  readonly newPassword2Control = new FormControl(
    null,
    CustomValidators.equalTo(this.newPassword1Control as any) as unknown as ValidatorFn
  );
  readonly form = new CitydealsFormGroup({
    oldPassword: this.oldPasswordControl,
    newPassword1: this.newPassword1Control,
    newPassword2: this.newPassword2Control,
  });
  showPassword = false;

  #store: Store;
  #actions$: Actions;
  #router: Router;
  #messageService: MessageService;
  #translocoService: TranslocoService;

  constructor(
    store: Store,
    actions$: Actions,
    router: Router,
    messageService: MessageService,
    translocoService: TranslocoService,
    errorFormConfig: NgxFormErrorConfig
  ) {
    this.#store = store;
    this.#actions$ = actions$;
    this.#router = router;
    this.#messageService = messageService;
    this.#translocoService = translocoService;

    this.watchSuccessLogin();

    errorFormConfig.updateMessages({
      equalTo: translocoService.translate('USER.CHANGE_PASSWORD.FORM.CONTROL.NEW_PASSWORD2.ERROR.EQUAL_TO'),
    });
  }

  watchSuccessLogin() {
    this.#actions$.pipe(ofActionSuccessful(ChangePasswordAction), untilDestroyed(this)).subscribe(() => {
      this.form.enable();
      this.form.reset();
      this.#messageService.add({
        key: 'change-password',
        severity: 'success',
        summary: this.#translocoService.translate('USER.CHANGE_PASSWORD.FORM.SUCCESS_NOTIFI'),
      });
    });
  }

  onSubmit() {
    this.form.submitted = true;
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const { oldPassword, newPassword1, newPassword2 } = this.form.value;
      this.form.disable();
      this.#store.dispatch(new ChangePasswordAction(oldPassword, newPassword1, newPassword2)).subscribe({
        error: error => {
          this.form.enable();
          this.#messageService.add({
            key: 'change-password',
            severity: 'error',
            summary: this.#translocoService.translate('USER.CHANGE_PASSWORD.FORM.REMOTE_ERROR_NOTIFI_TITLE'),
            detail: error.error.message,
          });
        },
      });
    }
  }
}
